export const RENTER_FORM_EXPERIMENT = 'renter_form_experiment';

export const BX_HYBRID_SEARCH_EXPERIMENT = 'vx_desktop_bx_863_hybrid_listing';

export const NEWBUILDING_MONTHLY_PAYMENT = 'newbuilding_monthly_payment_desktop';
export const AUD_DESKTOP_BX842_SEARCH_STRING_LISTING = 'aud_desktop_bx842_search_string_listing';

export const COMMON_CPD_LANDING_EXPERIMENT = 'newbuilding_common_cpd_page_restart';

export const NEWBUILDING_BOOKING_AUTH_EXPERIMENT = 'newbuilding_booking_authorization_desktop_v2';

export const NEWBUILDING_BOOKING_BANNER_MESSAGING_EXPERIMENT = 'newbuilding_booking_banner_messaging_desktop';

export const EXPERIMENTS: string[] = [
  RENTER_FORM_EXPERIMENT,
  NEWBUILDING_MONTHLY_PAYMENT,
  AUD_DESKTOP_BX842_SEARCH_STRING_LISTING,
  COMMON_CPD_LANDING_EXPERIMENT,
  NEWBUILDING_BOOKING_AUTH_EXPERIMENT,
  NEWBUILDING_BOOKING_BANNER_MESSAGING_EXPERIMENT,
];
